import { AdminService } from '@/application/service/AdminService';
import { AdminApiAdapter } from '@/infrastructure/api/AdminApiAdapter';

export const adminService = new AdminService(new AdminApiAdapter());
